"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Org/SubscriptionsTab/Features/ExtraPhoneNumber/PhonePickerModal/Form.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reacthookform = require('react-hook-form');






var _newTeamPhone = require('shared/validation/newTeamPhone');
var _asyncDebounce = require('shared/services/asyncDebounce'); var _asyncDebounce2 = _interopRequireDefault(_asyncDebounce);
var _phone = require('shared/services/phone');
var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _noticeBar = require('web/services/context/noticeBar');

var _Form = require('web/components/Form');
var _components = require('web/components/Upgrade/UpgradeModal/components');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

















const cancelObj = {}
const getAvailablePhoneNumbers = _asyncDebounce2.default.call(void 0, 
  (AreaCode) => _actions2.default.getAvailablePhoneNumbers({ AreaCode }),
  200,
  { cancelObj },
)

const PhonePickerForm = ({
  orgKey,
  onBack,
  onRegistered,
  onReloadSubscription,
}) => {
  const { register, formState, watch, setValue, handleSubmit } =
    _reacthookform.useForm({ mode: 'onChange', resolver: _newTeamPhone.newTeamPhoneResolver })
  const { errors, isValid, isDirty } = formState

  const setPhoneNumber = _react.useCallback.call(void 0, 
    (p) => setValue('phoneNumber', p, { shouldValidate: true }),
    [setValue],
  )
  const [availableNumbers, setAvailableNumbers] = _react.useState([])
  const [isLoadingNumbers, setIsLoadingNumbers] = _react.useState.call(void 0, false)
  const [hasFetchError, setHasFetchError] = _react.useState.call(void 0, false)
  const phoneNumber = watch('phoneNumber')
  const areaCode = watch('areaCode')
  const hasAreaCodeError = !!errors.areaCode
  const isAreaCodeValid = !hasAreaCodeError && _optionalChain([areaCode, 'optionalAccess', _2 => _2.length]) === _newTeamPhone.AREA_CODE_LENGTH

  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  // Generation guard for the debounced fetch: an edit to an invalid area code
  // early-returns without going through the debouncer, so it can't supersede a
  // still-in-flight request — that stale response must not repopulate the list
  // (or leave the skeleton shimmering) for an area code no longer entered.
  const fetchGenRef = _react.useRef.call(void 0, 0)
  const refreshPhoneNumbers = _react.useCallback.call(void 0, 
    () => {
      const gen = ++fetchGenRef.current
      setPhoneNumber('')
      setAvailableNumbers([])
      setHasFetchError(false)
      if (!isAreaCodeValid) {
        setIsLoadingNumbers(false)
        return
      }
      setIsLoadingNumbers(true)
      getAvailablePhoneNumbers(areaCode)
        .then(r => {
          if (gen !== fetchGenRef.current) return
          setAvailableNumbers(r.AvailableNumbers.map(x => x.PhoneNumber))
          setIsLoadingNumbers(false)
        })
        .catch(e => {
          // A debounced-out call rejects with `cancelObj`; bail before touching
          // any state so it can't clear the loading flag of (or flag an error
          // on) the newer in-flight request that superseded it.
          if (e === cancelObj || gen !== fetchGenRef.current) return
          setIsLoadingNumbers(false)
          setHasFetchError(true)
          showWarningBar('Failed to fetch available phone numbers')
        })
    },
    [isAreaCodeValid, areaCode, setPhoneNumber, showWarningBar],
  )
  _react.useEffect.call(void 0, refreshPhoneNumbers, [refreshPhoneNumbers])

  const onTileKeyDown = (e, p) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      setPhoneNumber(p)
    }
  }

  const onSubmit = _react.useCallback.call(void 0, 
    // On server-confirmed registration: signal success (close the modal / advance
    // the onboarding step) and toast immediately, then refresh the subscription in
    // the background. The reload is deliberately fire-and-forget with its own
    // distinct, non-blocking message — a stale plan view is a lesser evil than
    // stranding the user on the picker inviting a retry the entitlement guard now
    // rejects. Only a genuine registration failure shows "Failed to assign …".
    data => _actions2.default.registerPhone({ OrgKey: orgKey, PhoneNumber: data.phoneNumber })
      .then(() => {
        onRegistered()
        showSuccessBar(`${_phone.formatPhoneNumber.call(void 0, data.phoneNumber)} has been assigned to a team`)
        onReloadSubscription().catch(() =>
          showWarningBar('Your number was assigned — reload the page to see it on your plan.'))
      })
      .catch(() => showWarningBar('Failed to assign phone number')),
    [orgKey, showSuccessBar, showWarningBar, onRegistered, onReloadSubscription],
  )

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_components.Header, { title: "Select a phone number"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 128}} )
      , _react2.default.createElement('div', { className: "pick-phone--wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 129}}
        , _react2.default.createElement('span', { className: "pick-phone--subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 130}}, "Type an area code to view available phone numbers."

        )
        , _react2.default.createElement(_Form.InputSectionWrapper, {
          title: "Enter area code"  ,
          errorMessage: _optionalChain([errors, 'access', _3 => _3.areaCode, 'optionalAccess', _4 => _4.message]), __self: this, __source: {fileName: _jsxFileName, lineNumber: 133}}

          , _react2.default.createElement('div', { className: "pick-phone--form", __self: this, __source: {fileName: _jsxFileName, lineNumber: 137}}
            , _react2.default.createElement(_Form.TextInput, {
              autoFocus: true,
              placeholder: "E.g. 415" ,
              hasError: hasAreaCodeError,
              maxLength: _newTeamPhone.AREA_CODE_LENGTH,
              wrapperClassName: "pick-phone--form-input",
              ...register('areaCode'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 138}}
            )
            , _react2.default.createElement(_Form.Button, {
              isDisabled: !isAreaCodeValid,
              onClick: refreshPhoneNumbers,
              className: "pick-phone--form-refresh-btn", __self: this, __source: {fileName: _jsxFileName, lineNumber: 146}}

              , _react2.default.createElement('img', { src: "/assets/icons/refresh-white.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 151}} )
            )
          )
        )
        , _react2.default.createElement('div', { className: "pick-phone--results-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 155}}
          ,  isLoadingNumbers && Array.from({ length: 6 }).map((_, i) => (
            _react2.default.createElement('div', {
              key: `skeleton-${i}`,
              className: "pick-phone--result pick-phone--result--skeleton" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 157}}
            )
          ))
          ,  !isLoadingNumbers && hasFetchError && (
            _react2.default.createElement('div', { className: "pick-phone--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 163}}
              , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 164}}, "We couldn't load numbers. "    )
              , _react2.default.createElement(_Form.Button, {
                isSecondary: true,
                onClick: refreshPhoneNumbers,
                className: "pick-phone--retry", __self: this, __source: {fileName: _jsxFileName, lineNumber: 165}}
, "Retry"

              )
            )
          )
          ,  !isLoadingNumbers && !hasFetchError && isAreaCodeValid && !availableNumbers.length && (
            _react2.default.createElement('div', { className: "pick-phone--empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 175}}, "No numbers available for area code "
                    ,  areaCode , " — try a nearby one."
            )
          )
          ,  !isLoadingNumbers && !hasFetchError && availableNumbers.map(p => (
            _react2.default.createElement('div', {
              key: p,
              role: "button",
              tabIndex: 0,
              onClick: () => setPhoneNumber(p),
              onKeyDown: e => onTileKeyDown(e, p),
              className: _classBuilder2.default.call(void 0, 
                'pick-phone--result',
                p === phoneNumber && 'pick-phone--result--selected',
              ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 180}}

              ,  _phone.formatPhoneNumber.call(void 0, p) 
            )
          ))
        )
      )
      , _react2.default.createElement(_components.Controls, {
        onSecondaryClick: onBack,
        secondaryLabel: "Back",
        isPrimaryDisabled: !isValid || !isDirty,
        primaryLabel: "Continue",
        onPrimaryClick: handleSubmit(onSubmit), __self: this, __source: {fileName: _jsxFileName, lineNumber: 196}}
      )
    )
  )
}

exports. default = PhonePickerForm
